import React from 'react'
import './ProviderBadge.css'

export type ProviderBadgeSize = 'small' | 'medium'

export interface ProviderBadgeProps {
  provider?: string | null
  size?: ProviderBadgeSize
}

const labelFor = (provider?: string | null) => {
  if (!provider) return 'Unknown'
  const normalized = provider.toLowerCase()
  if (normalized === 'opentrack') return 'OpenTrack'
  if (normalized === 'dealer_vault') return 'DealerVault'
  return provider
}

// Icons removed from UI per request. Keep label-only rendering for a cleaner look.

export const ProviderBadge: React.FC<ProviderBadgeProps> = ({ provider, size = 'small' }) => {
  const normalized = provider?.toLowerCase()
  const baseClass = `provider-badge size-${size}`
  const variantClass =
    normalized === 'opentrack'
      ? 'provider-opentrack'
      : normalized === 'dealer_vault'
        ? 'provider-dealervault'
        : 'provider-unknown'

  return (
    <span className={`${baseClass} ${variantClass}`}>
      <span className="badge-label">{labelFor(provider)}</span>
    </span>
  )
}
